<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">注文データ検索</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-row no-gutters class="mt-4">
				<v-col cols="6">
					<v-menu
						ref="menu"
						v-model="menu1"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="startDate"
								label="注文日(開始)"
								readonly
								outlined
								dense
								v-on="on"
								class="px-4"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="startDate"
							no-title
							scrollable
							locale="ja"
							@input="menu1 = false"
						>
						</v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="6">
					<v-menu
						ref="menu"
						v-model="menu2"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="endDate"
								label="注文日(終了)"
								class="px-4"
								outlined
								dense
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="endDate" no-title scrollable locale="ja" @input="menu2 = false">
						</v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="6">
					<v-text-field
						class="px-4"
						outlined
						dense
						v-model="orderNumberFrom"
						label="注文番号(開始)"
					></v-text-field>
				</v-col>
				<v-col cols="6">
					<v-text-field
						class="px-4"
						v-model="orderNumberTo"
						outlined
						dense
						label="注文番号(終了)"
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="supplier"
						class="px-4"
						outlined
						dense
						label="仕入先"
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="productNumber"
						class="px-4"
						outlined
						dense
						label="製造番号"
					></v-text-field>
				</v-col>
			</v-row>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-btn color="primary" @click="validateAndSearch()">検索</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			menu1: false,
			menu2: false,
			startDate: null,
			endDate: null,
			orderNumberFrom: null,
			orderNumberTo: null,
			supplier: null,
			productNumber: null,
			snackbar: false,
			snackbarMessage: "",
			snackbarColor: "",
			snackbarTimeout: 6000,
		}
	},
	methods: {
		validateAndSearch() {
			if (this.startDate > this.endDate) {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "開始日は終了日以前に設定してください。",
				})
			} else if (this.orderNumberFrom > this.orderNumberTo) {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "注文番号(開始)は注文番号(終了)よりも以前に設定してください。",
				})
			} else {
				this.searchOrders()
			}
		},

		searchOrders() {
			const orderNumberFromStr = this.orderNumberFrom
				? ("000000" + this.orderNumberFrom).slice(-6)
				: null
			const orderNumberToStr = this.orderNumberTo ? ("000000" + this.orderNumberTo).slice(-6) : null
			const params = {
				q: {
					order_date_gteq: this.startDate,
					order_date_lteq: this.endDate,
					order_number_gteq: orderNumberFromStr || "",
					order_number_lteq: orderNumberToStr || "",
					supplier_name_cont: this.supplier,
					order_data_components_order_component_ordered_product_product_number_cont:
						this.productNumber,
				},
			}
			this.$emit("search-orders", params)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},

	watch: {
		query: {
			handler: function (newVal, oldVal) {
				this.startDate = newVal.order_date_gteq
				this.endDate = newVal.order_date_lteq
				this.orderNumberFrom = newVal.order_number_gteq
				this.orderNumberTo = newVal.order_number_lteq
				this.supplier = newVal.supplier_name_cont
				this.productNumber =
					newVal.order_data_components_order_component_ordered_product_product_number_cont
			},
			deep: true,
		},
	},
}
</script>
